// ====================================================
// COMEX SALE PROMOTIONS
// TV + CEILING FANS
// Offer Ends: 6 September 2026
// ====================================================

(() => {
  "use strict";


  // ====================================================
  // CURRENT PRODUCT HANDLE
  // ====================================================

  const prodHandle = location.pathname.split("/").pop();


  // ====================================================
  // PRODUCT GROUPS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];


  // ----------------------------------------------------
  // TV - FREE RIPPLE SOUNDBAR
  // U Ultra + AL OLED
  // ----------------------------------------------------

  const FreeRipple = [
    "prism-u55-ultra-qd-mini-led-4k-ai-google-tvZ",
    "prism-u65-ultra-qd-mini-led-4k-ai-google-tvZ",
    "prism-u75-ultra-qd-mini-led-4k-ai-google-tvZ",
    "prism-u86-ultra-qd-mini-led-4k-ai-google-tvZ",
    "prism-55al-google-tvZ",
    "prism-65al-google-tvZ"
  ];


  // ----------------------------------------------------
  // TV - FIXED MOUNT + SOUNDBAR UPSIZE
  // Q43U / Q55U / Q65U
  // U55 2026 / U65 2026
  // ----------------------------------------------------

  const FixedMount43to100 = [
    "q43u-2026Z",
    "q55u-2026Z",
    "q65u-2026Z",
    "u55-2026Z",
    "u65-2026Z"
  ];


  // ----------------------------------------------------
  // TV - TILT MOUNT + SOUNDBAR UPSIZE
  // Q75U / Q85U / Q100U
  // U75 2026 / U75
  // U86
  // ----------------------------------------------------

  const TiltedMount55to86 = [
    "q75u-2026Z",
    "q85u-2026Z",
    "prism-q100-ultra-qled-google-tvZ",
    "u75-2026Z",
    "u75-qled-mini-led-googleZ",
    "prism-u86-qd-mini-ledZ"
  ];


  // ----------------------------------------------------
  // TV - QE SERIES
  // Q43QE / Q55QE / Q65QE / Q75QE
  // ----------------------------------------------------

  const QESeries = [
    "q43qe-2026Z",
    "q55qe-2026Z",
    "q65qe-2026Z",
    "q75qe-2026Z",
    "s32-google-tvZ",
    "prism-s40-google-tvZ",
    "prism-s43-google-tvZ"
  ];


  // ====================================================
  // HELPER
  // ====================================================

  function createBanner(
    img,
    title,
    desc,
    extra = "",
    freeTag = "EARLY BIRD 9.9 SALE"
  ) {

    const wrapper = document.createElement("div");

    wrapper.className = "free_gift_banner layout2";

    wrapper.innerHTML = `
      <div class="free-gift comex">

        <img src="${img}" alt="">

        <div class="info-wrapper">

          <div class="title-wrapper">
            <span class="free-tag">${freeTag}</span>
            <span class="title">${title}</span>
          </div>

          ${
            desc
              ? `<p class="description">${desc}</p>`
              : ""
          }

          ${
            extra
              ? `<span class="description red">${extra}</span>`
              : ""
          }

        </div>

      </div>
    `;

    return wrapper;
  }


  // ====================================================
  // BANNERS
  // ====================================================


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  function getCeilingFanWarrantyBanner() {

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/CFs_Desktop_cd7a14f0-d8da-4b5b-9180-85c8e15f33f1.png?v=1780035893",
      "Warranty extended from 1 year to 4 years full warranty, all parts + labour",
      "For all Oasis Fan models",
      "Offer Ends 13 September"
    );

  }


  // ----------------------------------------------------
  // FREE RIPPLE SOUNDBAR
  // ----------------------------------------------------

  function getFreeRippleSoundbar() {

    $(".saleboxwrap.add-on-prism-ripple").addClass("hide");

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Ripple_Desktop_c4bc25e8-280f-4c48-b75a-562ac39f735b.png?v=1780035892",
      "Free Ripple Soundbar (Worth $999)",
      "Only for U Ultra & AL OLED TVs",
      "Offer Ends 6 September"
    );

  }


  // ----------------------------------------------------
  // FIXED MOUNT
  // ----------------------------------------------------

  function getFixedMount43to100() {

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fixed_Mount_Soundbar.png?v=1788284313",
      "FREE Fixed Mount & Upsized Discount on Soundbar Bundle (Worth up to $1,598)",
      "Only for Q-Ultra & U Series TV",
      "Offer Ends 6 September"
    );

  }


  // ----------------------------------------------------
  // TILT MOUNT
  // ----------------------------------------------------

  function getTiltedMount55to86() {

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Tilt_Mount_Soundbar.png?v=1788284313",
      "FREE Tilt Mount & Upsized Discount on Soundbar Bundle (Worth up to $1,598)",
      "Only for Q-Ultra & U Series TV",
      "Offer Ends 6 September"
    );

  }


  // ----------------------------------------------------
  // QE SERIES
  // ----------------------------------------------------

  function getQESeriesBanner() {

    return createBanner(
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/QE_SOundbar.png?v=1788284313",
      "Upsized Discount for Soundbar Bundles",
      "Only for QE Series & S Series TV",
      "Offer Ends 6 September"
    );

  }


  // ====================================================
  // PROMOTION LOGIC
  // ====================================================

  let banner = null;


  // ----------------------------------------------------
  // CEILING FANS
  // ----------------------------------------------------

  if (ceilingFanProducts.includes(prodHandle)) {

    banner = getCeilingFanWarrantyBanner();


  // ----------------------------------------------------
  // TV - FREE RIPPLE
  // ----------------------------------------------------

  } else if (FreeRipple.includes(prodHandle)) {

    banner = getFreeRippleSoundbar();


  // ----------------------------------------------------
  // TV - FIXED MOUNT
  // ----------------------------------------------------

  } else if (FixedMount43to100.includes(prodHandle)) {

    banner = getFixedMount43to100();


  // ----------------------------------------------------
  // TV - TILT MOUNT
  // ----------------------------------------------------

  } else if (TiltedMount55to86.includes(prodHandle)) {

    banner = getTiltedMount55to86();


  // ----------------------------------------------------
  // TV - QE SERIES
  // ----------------------------------------------------

  } else if (QESeries.includes(prodHandle)) {

    banner = getQESeriesBanner();

  }


  // ====================================================
  // STOP IF NO PROMOTION
  // ====================================================

  if (!banner) return;


  // ====================================================
  // INJECT BANNER
  // ====================================================

  function inject() {

    const target =
      document.querySelector('[itemprop="offers"]') ||
      document.querySelector(".variant-selector") ||
      document.querySelector(".product-form");

    if (!target || !target.parentNode) {
      return;
    }

    target.parentNode.insertBefore(
      banner,
      target
    );

  }


  // ====================================================
  // DOM READY
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      inject
    );

  } else {

    inject();

  }


  // ====================================================
  // SPECIAL POSITIONING
  // 49AL / 49AL 240Hz
  // ====================================================

  $(function () {

    const allowedProducts = [
      "prism-49al-240hz-8662946447587",
      "prism-49al-8662946316515"
    ];

    const productId = $("body").attr("id");

    if (allowedProducts.includes(productId)) {

      $(".free_gift_banner").each(function () {

        if (!$(this).next(".cart-hdden").length) {

          $(this).insertAfter(".cart-hdden");

        }

      });

    }

  });

})();


/* end of pdp banners */
/* fans groupsell header */
(() => {
  "use strict";

  // ====================================================
  // CEILING FAN - WARRANTY TEXT UPDATE
  // ====================================================

  const ceilingFanProducts = [
    "prism-oasis",
    "oasis-pro",
    "oasis-pro-macaron"
  ];

  const prodHandle = location.pathname.split("/").pop();

  // Only run on the selected Ceiling Fan PDPs
  if (!ceilingFanProducts.includes(prodHandle)) {
    return;
  }


  // ====================================================
  // WARRANTY TEXT
  // ====================================================

  const warrantyText =
    "Standard Warranty: 4-Year Parts & Labour Warranty on LED Panel & Components (Excludes Remote & Receiver) + Lifetime Motor Warranty";


  // ====================================================
  // UPDATE WARRANTY CONTENT
  // ====================================================

  function updateWarrantyText() {

    // --------------------------------------------------
    // ADD-ON: EXTENDED WARRANTY
    // --------------------------------------------------

    const groupsellWarranty =
      document.querySelector(".groupsell-title span");

    if (groupsellWarranty) {
      groupsellWarranty.textContent = warrantyText;
    }


    // --------------------------------------------------
    // LIFETIME WARRANTY SECTION
    // Oasis / section-7
    // --------------------------------------------------

    const warrantySection =
      document.querySelector(".section-7");

    if (warrantySection) {

      const warrantyParagraph =
        warrantySection.querySelector(".text-wrap .page-width > p");

      if (warrantyParagraph) {

        warrantyParagraph.textContent =
          "Enjoy comprehensive warranty coverage with PRISM+. Benefit from a Lifetime Motor Warranty, 4-Year LED Panel Warranty, and 2-Year Warranty on the Remote Control & Receiver. Our expert technicians also provide professional servicing and installation for complete peace of mind.";

      }
    }
  }


  // ====================================================
  // RUN ONCE
  // ====================================================

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      updateWarrantyText,
      { once: true }
    );

  } else {

    updateWarrantyText();

  }

})();

/* end of groupsell header */

(function () {
  'use strict';

  /*
   * ============================================================
   * PRISM+ CEILING FAN WARRANTY UPDATE
   *
   * Applies to:
   * - Oasis
   * - Oasis Pro
   * - Oasis Pro Macaron
   *
   * Changes:
   *
   * COMPARISON TABLE
   * - PRISM+ LED Panel -> 4 years
   * - PRISM+ Labour & Transport -> 4 years
   * - Other Brands are NOT changed
   *
   * LIFETIME WARRANTY SECTION
   * - LED -> 4 Years
   * - Labour & Transport -> 4 Years
   *
   * BASIC WARRANTY / TECH SPECS
   * - LED Panel -> 4 years
   * - Labour & Transport -> 4 years
   *
   * EXTENDED WARRANTY
   * - Replace 3/5 years badge with new 5-year badge
   *
   * No date condition.
   * ============================================================
   */


  /* ------------------------------------------------------------
   * SETTINGS
   * ------------------------------------------------------------ */

  var LED_YEARS = '4 years';
  var LED_YEARS_SLICE = '4 Years';

  var LABOUR_YEARS = '4 years';
  var LABOUR_YEARS_SLICE = '4 Years';

  var NEW_BADGE =
    'https://cdn.shopify.com/s/files/1/0703/1498/3651/files/badge-5yrs.png?v=1767765456';


  /* ------------------------------------------------------------
   * FAN PAGE DETECTION
   *
   * We don't rely on the product URL because Shopify product
   * handles/paths can change.
   *
   * "Natural Wind" is specific to the fan comparison table.
   * ------------------------------------------------------------ */

  function isFanPage() {

    var pageText = document.body
      ? document.body.textContent.toLowerCase()
      : '';

    return (
      pageText.indexOf('natural wind') !== -1 ||
      pageText.indexOf('smart mobile app') !== -1 &&
      pageText.indexOf('ceiling fan') !== -1
    );

  }


  /* ------------------------------------------------------------
   * HELPER
   * ------------------------------------------------------------ */

  function cleanText(text) {

    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  }


  /* ------------------------------------------------------------
   * 1. COMPARISON TABLE
   *
   * Example:
   *
   *                 PRISM+   Other   PRISM+   Other
   * LED Panel         2        2       2       2
   * Labour            1        1       1       1
   *
   * Becomes:
   *
   * LED Panel         4        2       4       2
   * Labour            4        1       4       1
   *
   * Only the two PRISM+ columns are changed.
   * ------------------------------------------------------------ */


  function updateComparisonTables() {

    var tables = document.querySelectorAll(
      '.comparison-chart table, .table-chart table'
    );

    tables.forEach(function (table) {

      var rows = table.querySelectorAll('tr');

      rows.forEach(function (row) {

        var titleCell = row.querySelector('td.title');

        if (!titleCell) {
          return;
        }

        var title = String(titleCell.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        var newValue = null;

        if (title === 'led panel') {
          newValue = '4 years';
        }

        if (title === 'labour & transport') {
          newValue = '4 years';
        }

        if (!newValue) {
          return;
        }

        /*
        * The Warranty category uses rowspan, so the number of
        * DOM children before the title differs from other rows.
        *
        * We therefore locate the title cell first and work from
        * there:
        *
        * title
        *   ↓
        * PRISM+ Smart
        *   ↓
        * Other Brands
        *   ↓
        * PRISM+ Standard
        *   ↓
        * Other Brands
        */

        var cells = Array.from(row.children);
        var titleIndex = cells.indexOf(titleCell);

        if (titleIndex === -1) {
          return;
        }

        var prismSmart = cells[titleIndex + 1];
        var prismStandard = cells[titleIndex + 3];

        /*
        * ONLY update PRISM+ columns.
        * Other Brands columns are intentionally untouched.
        */

        if (prismSmart) {
          prismSmart.textContent = newValue;
        }

        if (prismStandard) {
          prismStandard.textContent = newValue;
        }

      });

    });

  }



  /* ------------------------------------------------------------
   * 2. LIFETIME WARRANTY SLICE
   *
   * Supports both versions:
   *
   * Oasis / Oasis Pro:
   *
   * <div class="text-item">
   *   <p class="subtitle-text">LED</p>
   *   <p class="smalltxt">2 Years</p>
   * </div>
   *
   *
   * Oasis Pro Macaron:
   *
   * <div class="text-item subtitle-text">
   *   <p>LED</p>
   *   <p><strong>2 Years</strong></p>
   * </div>
   * ------------------------------------------------------------ */

  function updateLifetimeWarranty() {

    /*
     * Look specifically for warranty slices containing
     * "Quality Assurance".
     */

    var sections = document.querySelectorAll(
      '.section-8, .pdp-section'
    );

    sections.forEach(function (section) {

      var sectionText = cleanText(section.textContent);

      if (
        sectionText.indexOf('quality assurance') === -1 ||
        sectionText.indexOf('lifetime warranty') === -1
      ) {
        return;
      }

      /*
       * Find each text item.
       */

      var items = section.querySelectorAll(
        '.text-flex .text-item'
      );

      items.forEach(function (item) {

        var labelElement = item.querySelector(
          '.subtitle-text'
        );

        /*
         * Macaron uses .text-item.subtitle-text,
         * so if there isn't a nested .subtitle-text,
         * use the first <p>.
         */

        if (!labelElement) {
          labelElement = item.querySelector('p');
        }

        if (!labelElement) {
          return;
        }

        var label = cleanText(
          labelElement.textContent
        );

        /*
         * LED
         */

        if (
          label === 'led' ||
          label.indexOf('led') === 0
        ) {

          setWarrantyValue(
            item,
            LED_YEARS_SLICE
          );

        }

        /*
         * Labour & Transport
         */

        if (
          label.indexOf('labour & transport') !== -1
        ) {

          setWarrantyValue(
            item,
            LABOUR_YEARS_SLICE
          );

        }

      });

    });

  }


  function setWarrantyValue(item, value) {

    /*
     * Macaron:
     * <strong>2 Years</strong>
     */

    var strong = item.querySelector('strong');

    if (strong) {
      strong.textContent = value;
      return;
    }

    /*
     * Oasis / Oasis Pro:
     * <p class="smalltxt">2 Years</p>
     */

    var smallText = item.querySelector('.smalltxt');

    if (smallText) {
      smallText.textContent = value;
      return;
    }

    /*
     * Fallback:
     * Use the last paragraph.
     */

    var paragraphs = item.querySelectorAll('p');

    if (paragraphs.length > 1) {

      paragraphs[
        paragraphs.length - 1
      ].textContent = value;

    }

  }


  /* ------------------------------------------------------------
   * 3. BASIC WARRANTY / TECH SPECS
   *
   * Changes:
   *
   * LED Panel
   * 2 years -> 4 years
   *
   * Labour & Transport
   * 1 year -> 4 years
   *
   * Only the BASIC warranty value is changed.
   * Hidden Extended Warranty values remain untouched.
   * ------------------------------------------------------------ */

  function updateBasicWarranty() {

    var tables = document.querySelectorAll(
      '.vwo_specBlock.warranty table'
    );

    tables.forEach(function (table) {

      var rows = table.querySelectorAll('tr');

      rows.forEach(function (row) {

        var heading = row.querySelector('th');

        if (!heading) {
          return;
        }

        var title = cleanText(
          heading.textContent
        );

        var newValue = null;

        if (title === 'led panel') {
          newValue = LED_YEARS;
        }

        if (title === 'labour & transport') {
          newValue = LABOUR_YEARS;
        }

        if (!newValue) {
          return;
        }

        /*
         * First TD is the Basic Warranty value.
         *
         * Do NOT modify the hidden extended warranty cells.
         */

        var cells = row.querySelectorAll('td');

        if (cells.length) {
          cells[0].textContent = newValue;
        }

      });

    });

  }


  /* ------------------------------------------------------------
   * 4. EXTENDED WARRANTY BADGE
   *
   * Replace:
   * badge_3-5.png
   *
   * with:
   * badge-5yrs.png
   * ------------------------------------------------------------ */

  function updateExtendedWarrantyBadge() {

    var headings = document.querySelectorAll(
      'h1, h2, h3, h4, p, span'
    );

    headings.forEach(function (heading) {

      if (
        cleanText(heading.textContent) !==
        'premium extended warranty'
      ) {
        return;
      }

      /*
       * Find the warranty section.
       */

      var section = heading.closest(
        '.section-9a, .product-info-sc, .shopify-section'
      );

      if (!section) {
        return;
      }

      var images = section.querySelectorAll('img');

      images.forEach(function (img) {

        var src = (
          img.getAttribute('src') || ''
        ).toLowerCase();

        /*
         * Existing badge.
         */

        if (
          src.indexOf('badge_3-5') !== -1 ||
          src.indexOf('badge-5yrs') !== -1
        ) {

          img.setAttribute(
            'src',
            NEW_BADGE
          );

          img.removeAttribute('srcset');

          img.setAttribute(
            'alt',
            '5 Years Extended Warranty'
          );

        }

      });

    });

  }


  /* ------------------------------------------------------------
   * RUN
   * ------------------------------------------------------------ */

  function updateFanWarranty() {

    if (!isFanPage()) {
      return;
    }

    updateComparisonTables();
    updateLifetimeWarranty();
    updateBasicWarranty();
    updateExtendedWarrantyBadge();

  }


  /* ------------------------------------------------------------
   * INITIAL RUN
   * ------------------------------------------------------------ */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      updateFanWarranty
    );

  } else {

    updateFanWarranty();

  }


  /* ------------------------------------------------------------
   * DYNAMIC CONTENT
   *
   * Shopify can render PDP sections after the initial page load.
   * Watch for those sections and run again when needed.
   * ------------------------------------------------------------ */

  var updateTimer = null;

  var observer = new MutationObserver(function () {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {

      updateFanWarranty();

    }, 150);

  });


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();


